module.exports = {"svg":{"$":{"t":"1530690229752","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"2013","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M734.684732 634.347512l52.769854 323.222519L510.976694 804.886607 234.497779 957.569008l52.772924-323.222519L64.381309 406.148184l308.1001-47.029106L510.976694 64.384379l138.501424 294.734698 308.09396 47.029106L734.684732 634.347512z","p-id":"2014","fill":"#f5c90f"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/Collection.svg
// module id = lPf1
// module chunks = 1